(function (global, factory) {
    typeof exports === 'object' && typeof module !== 'undefined' ? factory(exports, require('react/jsx-runtime'), require('react'), require('@react-three/fiber'), require('d3-force-3d'), require('d3-force-cluster-3d'), require('ngraph.circular.fixed'), require('d3-hierarchy'), require('ngraph.pagerank'), require('ngraph.centrality'), require('d3-scale'), require('zustand'), require('zustand/context'), require('ngraph.graph'), require('@react-three/drei'), require('three'), require('ellipsize'), require('@react-spring/three'), require('camera-controls'), require('reakeys'), require('hold-event'), require('react-use-gesture'), require('three-stdlib'), require('zustand/shallow'), require('ngraph.path'), require('classnames')) :
    typeof define === 'function' && define.amd ? define(['exports', 'react/jsx-runtime', 'react', '@react-three/fiber', 'd3-force-3d', 'd3-force-cluster-3d', 'ngraph.circular.fixed', 'd3-hierarchy', 'ngraph.pagerank', 'ngraph.centrality', 'd3-scale', 'zustand', 'zustand/context', 'ngraph.graph', '@react-three/drei', 'three', 'ellipsize', '@react-spring/three', 'camera-controls', 'reakeys', 'hold-event', 'react-use-gesture', 'three-stdlib', 'zustand/shallow', 'ngraph.path', 'classnames'], factory) :
    (global = typeof globalThis !== 'undefined' ? globalThis : global || self, factory(global.reagraph = {}, global.jsxRuntime, global.react, global.fiber, global.d3Force3d, global.forceCluster, global.circularLayout2d, global.d3Hierarchy, global.pagerank, global.centrality, global.d3Scale, global.create, global.createContext, global.ngraph, global.drei, global.three, global.ellipsize, global.three$1, global.ThreeCameraControls, global.reakeys, global.holdEvent, global.reactUseGesture, global.threeStdlib, global.shallow, global.path, global.classNames));
})(this, (function (exports, jsxRuntime, react, fiber, d3Force3d, forceCluster, circularLayout2d, d3Hierarchy, pagerank, centrality, d3Scale, create, createContext, ngraph, drei, three, ellipsize, three$1, ThreeCameraControls, reakeys, holdEvent, reactUseGesture, threeStdlib, shallow, path, classNames) { 'use strict';

    function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

    function _interopNamespace(e) {
        if (e && e.__esModule) return e;
        var n = Object.create(null);
        if (e) {
            Object.keys(e).forEach(function (k) {
                if (k !== 'default') {
                    var d = Object.getOwnPropertyDescriptor(e, k);
                    Object.defineProperty(n, k, d.get ? d : {
                        enumerable: true,
                        get: function () { return e[k]; }
                    });
                }
            });
        }
        n["default"] = e;
        return Object.freeze(n);
    }

    var forceCluster__default = /*#__PURE__*/_interopDefaultLegacy(forceCluster);
    var circularLayout2d__default = /*#__PURE__*/_interopDefaultLegacy(circularLayout2d);
    var pagerank__default = /*#__PURE__*/_interopDefaultLegacy(pagerank);
    var centrality__default = /*#__PURE__*/_interopDefaultLegacy(centrality);
    var create__default = /*#__PURE__*/_interopDefaultLegacy(create);
    var createContext__default = /*#__PURE__*/_interopDefaultLegacy(createContext);
    var ngraph__default = /*#__PURE__*/_interopDefaultLegacy(ngraph);
    var ellipsize__default = /*#__PURE__*/_interopDefaultLegacy(ellipsize);
    var ThreeCameraControls__default = /*#__PURE__*/_interopDefaultLegacy(ThreeCameraControls);
    var holdEvent__namespace = /*#__PURE__*/_interopNamespace(holdEvent);
    var shallow__default = /*#__PURE__*/_interopDefaultLegacy(shallow);
    var path__default = /*#__PURE__*/_interopDefaultLegacy(path);
    var classNames__default = /*#__PURE__*/_interopDefaultLegacy(classNames);

    /******************************************************************************
    Copyright (c) Microsoft Corporation.

    Permission to use, copy, modify, and/or distribute this software for any
    purpose with or without fee is hereby granted.

    THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
    REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
    AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
    INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
    LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
    OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
    PERFORMANCE OF THIS SOFTWARE.
    ***************************************************************************** */

    function __rest(s, e) {
        var t = {};
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
            t[p] = s[p];
        if (s != null && typeof Object.getOwnPropertySymbols === "function")
            for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
                if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                    t[p[i]] = s[p[i]];
            }
        return t;
    }

    function traverseGraph(nodes, nodeStack = []) {
        const currentDepth = nodeStack.length;
        for (const node of nodes) {
            const idx = nodeStack.indexOf(node);
            if (idx > -1) {
                const loop = [...nodeStack.slice(idx), node].map(d => d.data.id);
                throw new Error(`Invalid Graph: Circular node path detected: ${loop.join(' -> ')}.`);
            }
            if (currentDepth > node.depth) {
                node.depth = currentDepth;
                traverseGraph(node.out, [...nodeStack, node]);
            }
        }
    }
    /**
     * Gets the depth of the graph's nodes. Used in the radial layout.
     */
    function getNodeDepth(nodes, links) {
        let invalid = false;
        const graph = nodes.reduce((acc, cur) => (Object.assign(Object.assign({}, acc), { [cur.id]: {
                data: cur,
                out: [],
                depth: -1,
                ins: []
            } })), {});
        try {
            links.forEach(link => {
                // @ts-ignore
                const from = link.fromId || link.source;
                // @ts-ignore
                const to = link.toId || link.target;
                if (!graph.hasOwnProperty(from)) {
                    throw new Error(`Missing source Node ${from}`);
                }
                if (!graph.hasOwnProperty(to)) {
                    throw new Error(`Missing target Node ${to}`);
                }
                const sourceNode = graph[from];
                const targetNode = graph[to];
                targetNode.ins.push(sourceNode);
                sourceNode.out.push(targetNode);
            });
            traverseGraph(Object.values(graph));
        }
        catch (e) {
            invalid = true;
        }
        const allDepths = Object.keys(graph).map(id => graph[id].depth);
        const maxDepth = Math.max(...allDepths);
        return {
            invalid,
            depths: graph,
            maxDepth: maxDepth || 1
        };
    }

    const DAG_LEVEL_NODE_RATIO = 2;
    const RADIALS = ['radialin', 'radialout'];
    /**
     * Radial graph layout using D3 Force 3d.
     * Inspired by: https://github.com/vasturiano/three-forcegraph/blob/master/src/forcegraph-kapsule.js#L970-L1018
     */
    function forceRadial(nodes, links, dagMode = 'lr') {
        const { depths, maxDepth, invalid } = getNodeDepth(nodes, links);
        if (invalid) {
            return null;
        }
        const modeDistance = RADIALS.includes(dagMode) ? 1 : 5;
        const dagLevelDistance = (nodes.length / maxDepth) * DAG_LEVEL_NODE_RATIO * modeDistance;
        if (dagMode) {
            const getFFn = (fix, invert) => (node) => !fix
                ? undefined
                : (depths[node.id].depth - maxDepth / 2) *
                    dagLevelDistance *
                    (invert ? -1 : 1);
            const fxFn = getFFn(['lr', 'rl'].includes(dagMode), dagMode === 'rl');
            const fyFn = getFFn(['td', 'bu'].includes(dagMode), dagMode === 'td');
            const fzFn = getFFn(['zin', 'zout'].includes(dagMode), dagMode === 'zout');
            nodes.forEach(node => {
                node.fx = fxFn(node);
                node.fy = fyFn(node);
                node.fz = fzFn(node);
            });
        }
        return RADIALS.includes(dagMode)
            ? d3Force3d.forceRadial(node => {
                const nodeDepth = depths[node.id];
                const depth = dagMode === 'radialin' ? maxDepth - nodeDepth.depth : nodeDepth.depth;
                return depth * dagLevelDistance;
            }).strength(1)
            : null;
    }

    const TICK_COUNT = 100;
    const CLUSTER_PADDING = 10;
    const CLUSTER_STRENGTH = 0.5;
    function forceDirected({ graph, mode = null, dimensions = 2, nodeStrength = -250, linkDistance = 50, drags, clusterAttribute }) {
        const nodes = [];
        const links = [];
        const cluster = new Map();
        // Map the graph nodes / edges to D3 object
        graph.forEachNode(n => {
            var _a;
            // @ts-ignore
            nodes.push(Object.assign(Object.assign({}, n), { 
                // This is for the clustering
                radius: ((_a = n.data) === null || _a === void 0 ? void 0 : _a.size) || 1 }));
        });
        graph.forEachLink(l => {
            // @ts-ignore
            links.push(Object.assign(Object.assign({}, l), { id: l.data.id, source: l.fromId, target: l.toId }));
        });
        // Dynamically adjust node strength based on the number of edges
        const is2d = dimensions === 2;
        const nodeStrengthAdjustment = is2d && links.length > 25 ? nodeStrength * 2 : nodeStrength;
        // Create the simulation
        const sim = d3Force3d.forceSimulation()
            .force('link', d3Force3d.forceLink())
            .force('charge', d3Force3d.forceManyBody().strength(nodeStrengthAdjustment))
            .force('x', d3Force3d.forceX())
            .force('y', d3Force3d.forceY())
            .force('z', d3Force3d.forceZ())
            // Handles nodes not overlapping each other ( most relevant in clustering )
            .force('collide', d3Force3d.forceCollide(d => d.radius + CLUSTER_PADDING))
            .force('dagRadial', forceRadial(nodes, links, mode))
            .stop();
        // Initialize the simulation
        const layout = sim
            .numDimensions(dimensions)
            .nodes(nodes)
            .force('cluster', forceCluster__default["default"]()
            .centers(node => {
            var _a, _b;
            // Happens after nodes passed so they have the x/y/z
            if (clusterAttribute) {
                const nodeClusterAttr = (_b = (_a = node.data) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b[clusterAttribute];
                const centerNode = cluster.get(nodeClusterAttr);
                if (!centerNode) {
                    const largestNode = nodes.reduce((last, cur) => {
                        var _a, _b;
                        if (((_b = (_a = cur.data) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b[clusterAttribute]) === nodeClusterAttr) {
                            return cur.radius > last.radius ? cur : last;
                        }
                        return last;
                    }, node);
                    cluster.set(nodeClusterAttr, largestNode);
                    return largestNode;
                }
                return centerNode;
            }
        })
            .strength(CLUSTER_STRENGTH));
        // Run the force on the links
        const linkForce = layout.force('link');
        if (linkForce) {
            linkForce
                .id(d => d.id)
                .links(links)
                // When no mode passed, its a tree layout
                // so let's use a larger distance
                .distance(linkDistance);
        }
        const nodeMap = new Map(nodes.map(n => [n.id, n]));
        return {
            step() {
                // Run the ticker 100 times so
                // we don't overdo the animation
                sim.tick(TICK_COUNT);
                return true;
            },
            getNodePosition(id) {
                // If we dragged, we need to use that position
                return (drags === null || drags === void 0 ? void 0 : drags[id]) || nodeMap.get(id);
            }
        };
    }

    const circular2d = ({ graph }) => circularLayout2d__default["default"](graph, {
        radius: 300,
        center: { x: 0, y: 0 }
    });

    const DIRECTION_MAP = {
        td: {
            x: 'x',
            y: 'y',
            factor: -1
        },
        lr: {
            x: 'y',
            y: 'x',
            factor: 1
        }
    };
    function hierarchical({ graph, mode = 'td' }) {
        const nodes = [];
        const links = [];
        // Map the graph nodes / edges to D3 object
        graph.forEachNode(n => {
            nodes.push(Object.assign({}, n));
        });
        graph.forEachLink(l => {
            links.push(Object.assign(Object.assign({}, l), { id: l.data.id, source: l.fromId, target: l.toId }));
        });
        const { depths } = getNodeDepth(nodes, links);
        const rootNodes = Object.keys(depths).map(d => depths[d]);
        const root = d3Hierarchy.stratify()
            .id(d => d.data.id)
            .parentId(d => { var _a, _b, _c; return (_c = (_b = (_a = d.ins) === null || _a === void 0 ? void 0 : _a[0]) === null || _b === void 0 ? void 0 : _b.data) === null || _c === void 0 ? void 0 : _c.id; })(rootNodes);
        const treeRoot = d3Hierarchy.tree()
            .separation(() => 1)
            .nodeSize([50, 50])(d3Hierarchy.hierarchy(root));
        const treeNodes = treeRoot.descendants();
        const path = DIRECTION_MAP[mode];
        const mappedNodes = new Map(nodes.map(n => {
            let { x, y } = treeNodes.find((t) => t.data.id === n.id);
            return [
                n.id,
                Object.assign(Object.assign({}, n), { [path.x]: x * path.factor, [path.y]: y * path.factor, z: 0 })
            ];
        }));
        return {
            step() {
                return true;
            },
            getNodePosition(id) {
                return mappedNodes.get(id);
            }
        };
    }

    function layoutProvider(_a) {
        var { type } = _a, rest = __rest(_a, ["type"]);
        if (type === 'forceDirected2d') {
            return forceDirected(Object.assign(Object.assign({}, rest), { dimensions: 2, nodeStrength: -250, linkDistance: 50 }));
        }
        else if (type === 'treeTd2d') {
            return forceDirected(Object.assign(Object.assign({}, rest), { mode: 'td', dimensions: 2, nodeStrength: -250, linkDistance: 100 }));
        }
        else if (type === 'treeLr2d') {
            return forceDirected(Object.assign(Object.assign({}, rest), { mode: 'lr', dimensions: 2, nodeStrength: -250, linkDistance: 100 }));
        }
        else if (type === 'radialOut2d') {
            return forceDirected(Object.assign(Object.assign({}, rest), { mode: 'radialout', dimensions: 2, nodeStrength: -250, linkDistance: 100 }));
        }
        else if (type === 'treeTd3d') {
            return forceDirected(Object.assign(Object.assign({}, rest), { mode: 'td', dimensions: 3, nodeStrength: -500, linkDistance: 50 }));
        }
        else if (type === 'treeLr3d') {
            return forceDirected(Object.assign(Object.assign({}, rest), { mode: 'lr', dimensions: 3, nodeStrength: -500, linkDistance: 50 }));
        }
        else if (type === 'radialOut3d') {
            return forceDirected(Object.assign(Object.assign({}, rest), { mode: 'radialout', dimensions: 3, nodeStrength: -500, linkDistance: 100 }));
        }
        else if (type === 'forceDirected3d') {
            return forceDirected(Object.assign(Object.assign({}, rest), { dimensions: 3, nodeStrength: -250, linkDistance: 50 }));
        }
        else if (type === 'circular2d') {
            return circular2d(rest);
        }
        else if (type === 'hierarchicalTd') {
            return hierarchical(Object.assign(Object.assign({}, rest), { mode: 'td' }));
        }
        else if (type === 'hierarchicalLr') {
            return hierarchical(Object.assign(Object.assign({}, rest), { mode: 'lr' }));
        }
        throw new Error(`Layout ${type} not found.`);
    }

    function tick(layout, cb) {
        let stable;
        function run() {
            if (!stable) {
                stable = layout.step();
                run();
            }
            else {
                cb(stable);
            }
        }
        run();
    }

    function recommendLayout(nodes, edges) {
        const { invalid } = getNodeDepth(nodes, edges);
        const nodeCount = nodes.length;
        if (!invalid) {
            // Large tree layouts
            if (nodeCount > 100) {
                return 'radialOut2d';
            }
            else {
                // Smaller tree layouts
                return 'treeTd2d';
            }
        }
        // Circular layouts
        return 'forceDirected2d';
    }

    function pageRankSizing({ graph }) {
        const ranks = pagerank__default["default"](graph);
        return {
            ranks,
            getSizeForNode: (nodeID) => ranks[nodeID] * 80
        };
    }

    function centralitySizing({ graph, minSize, maxSize }) {
        const ranks = centrality__default["default"].closeness(graph);
        return {
            ranks,
            getSizeForNode: (nodeID) => ranks[nodeID] * 20
        };
    }

    function attributeSizing({ graph, attribute, defaultSize }) {
        const map = new Map();
        if (attribute) {
            graph.forEachNode(node => {
                const size = node.data.data[attribute];
                if (isNaN(size)) {
                    console.warn(`Attribute ${size} is not a number for node ${node.id}`);
                }
                map.set(node.id, size || 0);
            });
        }
        else {
            console.warn('Attribute sizing configured but no attribute provided');
        }
        return {
            getSizeForNode: (nodeId) => {
                if (!attribute || !map) {
                    return defaultSize;
                }
                return map.get(nodeId);
            }
        };
    }

    const providers = {
        pagerank: pageRankSizing,
        centrality: centralitySizing,
        attribute: attributeSizing,
        none: ({ defaultSize }) => ({
            getSizeForNode: (_id) => defaultSize
        })
    };
    function nodeSizeProvider(_a) {
        var _b;
        var { type } = _a, rest = __rest(_a, ["type"]);
        const provider = (_b = providers[type]) === null || _b === void 0 ? void 0 : _b.call(providers, rest);
        if (!provider) {
            throw new Error(`Unknown sizing strategy: ${type}`);
        }
        const { graph, minSize, maxSize } = rest;
        const sizes = new Map();
        let min;
        let max;
        graph.forEachNode(node => {
            var _a;
            const size = ((_a = node.data) === null || _a === void 0 ? void 0 : _a.size) || provider.getSizeForNode(node.id);
            if (min === undefined || size < min) {
                min = size;
            }
            if (max === undefined || size > max) {
                max = size;
            }
            sizes.set(node.id, size);
        });
        if (type !== 'none') {
            const scale = d3Scale.scaleLinear()
                .domain([min, max])
                .rangeRound([minSize, maxSize]);
            for (const [nodeId, size] of sizes) {
                sizes.set(nodeId, scale(size));
            }
        }
        return sizes;
    }

    const NODE_THRESHOLD = 20;
    function calcLabelVisibility(nodeCount, type) {
        return (shape, size) => {
            if (type === 'all') {
                return true;
            }
            else if (type === 'nodes' && shape === 'node') {
                return true;
            }
            else if (type === 'edges' && shape === 'edge') {
                return true;
            }
            else if (type === 'auto' && shape === 'node') {
                if (nodeCount <= NODE_THRESHOLD) {
                    return true;
                }
                else {
                    return size > 7;
                }
            }
            return false;
        };
    }
    function getLabelOffsetByType(offset, position) {
        switch (position) {
            case 'above':
                return offset;
            case 'below':
                return -offset;
            case 'inline':
            case 'natural':
            default:
                return 0;
        }
    }

    function buildGraph(graph, nodes, edges) {
        graph.clear();
        graph.beginUpdate();
        for (const node of nodes) {
            graph.addNode(node.id, node);
        }
        for (const edge of edges) {
            graph.addLink(edge.source, edge.target, edge);
        }
        graph.endUpdate();
    }
    function transformGraph({ graph, layout, sizingType, labelType, sizingAttribute, defaultNodeSize, minNodeSize, maxNodeSize }) {
        const nodes = [];
        const edges = [];
        const map = new Map();
        const sizes = nodeSizeProvider({
            graph,
            type: sizingType,
            attribute: sizingAttribute,
            minSize: minNodeSize,
            maxSize: maxNodeSize,
            defaultSize: defaultNodeSize
        });
        const nodeCount = graph.getNodesCount();
        const checkVisibility = calcLabelVisibility(nodeCount, labelType);
        graph.forEachNode((node) => {
            if (node.data) {
                const position = layout.getNodePosition(node.id);
                const _a = node.data, { data, fill, icon, label, size, hidden } = _a, rest = __rest(_a, ["data", "fill", "icon", "label", "size", "hidden"]);
                const nodeSize = sizes.get(node.id);
                const labelVisible = checkVisibility('node', nodeSize);
                const nodeLinks = graph.getLinks(node.id);
                const parents = nodeLinks
                    ? [...nodeLinks].filter(l => l.toId === node.id).map(l => l.fromId)
                    : null;
                const n = Object.assign(Object.assign({}, node), { size: nodeSize, labelVisible,
                    label,
                    icon,
                    fill,
                    parents,
                    hidden, data: Object.assign(Object.assign({}, rest), (data || {})), position: Object.assign(Object.assign({}, position), { z: position.z || 1 }) });
                map.set(node.id, n);
                nodes.push(n);
            }
        });
        graph.forEachLink((link) => {
            const from = map.get(link.fromId);
            const to = map.get(link.toId);
            if (from && to) {
                const _a = link.data, { data, id, label, size, hidden } = _a, rest = __rest(_a, ["data", "id", "label", "size", "hidden"]);
                const labelVisible = checkVisibility('edge', link.size);
                edges.push(Object.assign(Object.assign({}, link), { id,
                    label,
                    labelVisible,
                    size,
                    hidden, data: Object.assign(Object.assign(Object.assign({}, rest), { id }), (data || {})) }));
            }
        });
        return {
            nodes,
            edges
        };
    }

    function getNestedParents(nodeId, nodes) {
        const parentNodeIds = [];
        const childNodes = nodes.filter(n => { var _a; return (_a = n.parents) === null || _a === void 0 ? void 0 : _a.includes(nodeId); });
        if (childNodes.length > 0) {
            parentNodeIds.push(nodeId);
            for (const child of childNodes) {
                parentNodeIds.push(...getNestedParents(child.id, nodes));
            }
        }
        return parentNodeIds;
    }
    const getUpdatedCollapsedState = ({ nodeIds, nodes, edges, graph }) => {
        let collapsedNodeIds = [];
        // Add any node ids that are nested parents that had their parent collapsed
        // ie gradparent -> parent -> node and grandparent was collapsed
        for (const collapsedId of nodeIds) {
            collapsedNodeIds.push(...getNestedParents(collapsedId, nodes));
        }
        // Reset hidden state of edges/nodes
        let updatedEdges = edges.map(e => (Object.assign(Object.assign({}, e), { hidden: false })));
        let updatedNodes = nodes.map(n => (Object.assign(Object.assign({}, n), { hidden: false })));
        // Keep track of which edges and nodes were hidden from this change
        const curHiddenEdgeIds = [];
        const curHiddenNodeIds = [];
        for (const collapsedId of collapsedNodeIds) {
            const nodeLinks = graph.getLinks(collapsedId);
            const outboundEdges = [...nodeLinks].filter(l => l.data.source === collapsedId);
            const outboundEdgeIds = outboundEdges.map(l => l.data.id);
            const outboundEdgeNodeIds = outboundEdges.map(l => l.data.target);
            updatedEdges = updatedEdges.map(e => {
                if (outboundEdgeIds.includes(e.id)) {
                    curHiddenEdgeIds.push(e.id);
                    return Object.assign(Object.assign({}, e), { hidden: true });
                }
                else if (curHiddenEdgeIds.includes(e.id)) {
                    return e;
                }
                return Object.assign(Object.assign({}, e), { hidden: false });
            });
            updatedNodes = updatedNodes.map(n => {
                if (!outboundEdgeNodeIds.includes(n.id) &&
                    !curHiddenNodeIds.includes(n.id)) {
                    return Object.assign(Object.assign({}, n), { hidden: false });
                }
                // Determine if there is another edge going to this node
                const curNodeLinks = graph.getLinks(n.id);
                const inboundNodeLinks = [...curNodeLinks].filter(l => l.data.target === n.id);
                if (inboundNodeLinks.length > 1 && !curHiddenNodeIds.includes(n.id)) {
                    // If all inbound links are hidden, hide this node as well
                    const inboundNodeLinkIds = inboundNodeLinks.map(l => l.data.id);
                    if (!inboundNodeLinkIds.every(i => curHiddenEdgeIds.includes(i))) {
                        return Object.assign(Object.assign({}, n), { hidden: false });
                    }
                }
                if (!curHiddenNodeIds.includes(n.id)) {
                    curHiddenNodeIds.push(n.id);
                    return Object.assign(Object.assign({}, n), { hidden: true });
                }
                return n;
            });
        }
        return {
            updatedEdges,
            updatedNodes,
            collapsedNodeIds
        };
    };

    const { Provider, useStore } = createContext__default["default"]();
    const createStore = () => create__default["default"](set => ({
        edges: [],
        nodes: [],
        collapsedNodeIds: [],
        panning: false,
        draggingId: null,
        selections: [],
        actives: [],
        drags: {},
        graph: ngraph__default["default"](),
        setPanning: panning => set(state => (Object.assign(Object.assign({}, state), { panning }))),
        setDrags: drags => set(state => (Object.assign(Object.assign({}, state), { drags }))),
        setDraggingId: draggingId => set(state => (Object.assign(Object.assign({}, state), { draggingId }))),
        setActives: actives => set(state => (Object.assign(Object.assign({}, state), { actives }))),
        setSelections: selections => set(state => (Object.assign(Object.assign({}, state), { selections }))),
        setNodes: nodes => set(state => (Object.assign(Object.assign({}, state), { nodes }))),
        setEdges: edges => set(state => (Object.assign(Object.assign({}, state), { edges }))),
        setNodePosition: (id, position) => set(state => {
            const node = state.nodes.find(n => n.id === id);
            // TODO: Come back and fix this so we don't have to double project
            const newNode = Object.assign(Object.assign(Object.assign({}, node), position), { position });
            return Object.assign(Object.assign({}, state), { drags: Object.assign(Object.assign({}, state.drags), { [id]: newNode }), nodes: [...state.nodes.filter(n => n.id !== id), newNode] });
        }),
        setCollapsedNodeIds: (nodeIds = []) => set(state => {
            const { updatedNodes, updatedEdges, collapsedNodeIds } = getUpdatedCollapsedState({
                nodeIds,
                nodes: [...state.nodes],
                edges: [...state.edges],
                graph: state.graph
            });
            return Object.assign(Object.assign({}, state), { edges: updatedEdges, nodes: updatedNodes, collapsedNodeIds });
        })
    }));

    const useGraph = ({ layoutType, sizingType, labelType, sizingAttribute, clusterAttribute, selections, nodes, edges, actives, collapsedNodeIds, defaultNodeSize, maxNodeSize, minNodeSize }) => {
        const [graph, stateNodes, stateEdges, stateCollapsedNodeIds, setEdges, setNodes, setSelections, setActives, drags, setDrags, setCollapsedNodeIds] = useStore(state => [
            state.graph,
            state.nodes,
            state.edges,
            state.collapsedNodeIds,
            state.setEdges,
            state.setNodes,
            state.setSelections,
            state.setActives,
            state.drags,
            state.setDrags,
            state.setCollapsedNodeIds
        ]);
        const [mounted, setMounted] = react.useState(false);
        const layoutMounted = react.useRef(false);
        const layout = react.useRef(null);
        // Transient updates
        const dragRef = react.useRef(drags);
        react.useEffect(() => {
            dragRef.current = drags;
        }, [drags]);
        const updateLayout = react.useCallback((curLayout) => {
            layout.current =
                curLayout ||
                    layoutProvider({
                        type: layoutType,
                        graph,
                        drags: dragRef.current,
                        clusterAttribute
                    });
            tick(layout.current, () => {
                const result = transformGraph({
                    graph,
                    layout: layout.current,
                    sizingType,
                    labelType,
                    sizingAttribute,
                    maxNodeSize,
                    minNodeSize,
                    defaultNodeSize
                });
                setEdges(result.edges);
                setNodes(result.nodes);
            });
        }, [
            defaultNodeSize,
            maxNodeSize,
            minNodeSize,
            layoutType,
            graph,
            sizingType,
            clusterAttribute,
            labelType,
            sizingAttribute,
            setEdges,
            setNodes
        ]);
        react.useEffect(() => {
            // Let's set the store selections so its easier to access
            setSelections(selections);
        }, [selections, setSelections]);
        react.useEffect(() => {
            // Let's set the store actives so its easier to access
            setActives(actives);
        }, [actives, setActives]);
        // Create the nggraph graph object
        react.useEffect(() => {
            buildGraph(graph, nodes, edges);
            updateLayout();
            // queue this in a frame so it only happens after the graph is built
            requestAnimationFrame(() => {
                // Track mounted in state and transitent state
                layoutMounted.current = true;
                setMounted(true);
            });
            // eslint-disable-next-line
        }, [nodes, edges, graph]);
        react.useEffect(() => {
            // Let's set the store collapsedNodeIds so its easier to access
            setCollapsedNodeIds(collapsedNodeIds);
        }, [collapsedNodeIds, setCollapsedNodeIds]);
        react.useEffect(() => {
            if (mounted) {
                // Update the layout of the graph when nodes are expanded/collapsed
                const graphEdges = stateEdges.map(e => (Object.assign(Object.assign({}, e), { source: e.fromId, target: e.toId, fromId: undefined, toId: undefined })));
                buildGraph(graph, stateNodes, graphEdges);
                updateLayout();
            }
            // eslint-disable-next-line react-hooks/exhaustive-deps
        }, [stateCollapsedNodeIds]);
        // Update layout on type changes
        react.useEffect(() => {
            if (layoutMounted.current) {
                // Set the transient and the state
                dragRef.current = {};
                setDrags({});
                // Recalculate the layout
                updateLayout();
            }
        }, [graph, layoutType, updateLayout, setDrags]);
        // Update layout on size, label changes
        react.useEffect(() => {
            if (layoutMounted.current) {
                updateLayout(layout.current);
            }
        }, [graph, sizingType, sizingAttribute, labelType, updateLayout]);
        return {
            mounted
        };
    };

    const Label = ({ text, fontSize, fontUrl, color, opacity, stroke, active, ellipsis }) => {
        const shortText = ellipsis && !active ? ellipsize__default["default"](text, ellipsis) : text;
        const normalizedColor = react.useMemo(() => new three.Color(color), [color]);
        const normalizedStroke = react.useMemo(() => (stroke ? new three.Color(stroke) : undefined), [stroke]);
        return (jsxRuntime.jsx(drei.Billboard, Object.assign({ position: [0, 0, 1] }, { children: jsxRuntime.jsx(drei.Text, Object.assign({ font: fontUrl, fontSize: fontSize, color: normalizedColor, fillOpacity: opacity, textAlign: "center", outlineWidth: stroke ? 1 : 0, outlineColor: normalizedStroke, depthOffset: 0, maxWidth: 100, overflowWrap: "break-word" }, { children: shortText })) })));
    };
    Label.defaultProps = {
        opacity: 1,
        fontSize: 7,
        color: '#2A6475',
        ellipsis: 75
    };

    const animationConfig = {
        mass: 10,
        tension: 1000,
        friction: 300,
        // Decreasing precision to improve performance from 0.00001
        precision: 0.1
    };

    function pointAtLine(from, to, size) {
        const { distance, fromVector, toVector } = calcDistance({ from, to });
        if (distance < size) {
            // NOTE: This is a hacky way to get the from position
            // we should not do this long term
            // @ts-ignore
            return from;
        }
        return fromVector.add(toVector.sub(fromVector).multiplyScalar(size / distance));
    }
    const getVectors = ({ from, to }) => [
        new three.Vector3(from.x, from.y || 0, from.z || 0),
        new three.Vector3(to.x, to.y || 0, to.z || 0)
    ];
    function calcDistance({ from, to }) {
        const [fromVector, toVector] = getVectors({ from, to });
        return {
            distance: fromVector.distanceTo(toVector),
            fromVector,
            toVector
        };
    }
    const getPoints = ({ from, to }) => ({
        from: pointAtLine(from.position, to.position, from.size),
        to: pointAtLine(to.position, from.position, to.size)
    });
    function getMidPoint(positions, offset = 0) {
        const [fromVector, toVector] = getVectors(positions);
        const midVector = new three.Vector3()
            .addVectors(fromVector, toVector)
            .divideScalar(2);
        return midVector.setLength(midVector.length() + offset);
    }
    function getArrowPosition(positions, arrowSize = 1) {
        const [from, to] = getVectors(positions);
        const diff = to.sub(from);
        return from.add(diff.setLength(diff.length() - arrowSize / 2));
    }
    function getQuaternion(positions) {
        const [fromVector, toVector] = getVectors(positions);
        const dir = new three.Vector3().subVectors(toVector, fromVector);
        const axis = new three.Vector3(0, 1, 0);
        return [axis, dir.clone().normalize()];
    }

    function getLayoutCenter(nodes) {
        let minX = Number.POSITIVE_INFINITY;
        let maxX = Number.NEGATIVE_INFINITY;
        let minY = Number.POSITIVE_INFINITY;
        let maxY = Number.NEGATIVE_INFINITY;
        let minZ = Number.POSITIVE_INFINITY;
        let maxZ = Number.NEGATIVE_INFINITY;
        for (let node of nodes) {
            minX = Math.min(minX, node.position.x);
            maxX = Math.max(maxX, node.position.x);
            minY = Math.min(minY, node.position.y);
            maxY = Math.max(maxY, node.position.y);
            minZ = Math.min(minZ, node.position.z);
            maxZ = Math.max(maxZ, node.position.z);
        }
        return {
            minX,
            maxX,
            minY,
            maxY,
            minZ,
            maxZ,
            x: (maxX + minX) / 2,
            y: (maxY + minY) / 2,
            z: (maxZ + minZ) / 2
        };
    }

    const lightTheme = {
        canvas: {
            background: '#fff',
            fog: '#fff'
        },
        node: {
            fill: '#7CA0AB',
            activeFill: '#1DE9AC',
            opacity: 1,
            selectedOpacity: 1,
            inactiveOpacity: 0.2,
            label: {
                color: '#2A6475',
                stroke: '#fff',
                activeColor: '#1DE9AC'
            }
        },
        lasso: {
            border: '1px solid #55aaff',
            background: 'rgba(75, 160, 255, 0.1)'
        },
        ring: {
            fill: '#D8E6EA',
            activeFill: '#1DE9AC'
        },
        edge: {
            fill: '#D8E6EA',
            activeFill: '#1DE9AC',
            opacity: 1,
            selectedOpacity: 1,
            inactiveOpacity: 0.1,
            label: {
                stroke: '#fff',
                color: '#2A6475',
                activeColor: '#1DE9AC'
            }
        },
        arrow: {
            fill: '#D8E6EA',
            activeFill: '#1DE9AC'
        }
    };
    const darkTheme = {
        canvas: {
            background: '#1E2026',
            fog: '#1E2026'
        },
        node: {
            fill: '#7A8C9E',
            activeFill: '#1DE9AC',
            opacity: 1,
            selectedOpacity: 1,
            inactiveOpacity: 0.2,
            label: {
                stroke: '#1E2026',
                color: '#ACBAC7',
                activeColor: '#1DE9AC'
            }
        },
        lasso: {
            border: '1px solid #55aaff',
            background: 'rgba(75, 160, 255, 0.1)'
        },
        ring: {
            fill: '#54616D',
            activeFill: '#1DE9AC'
        },
        edge: {
            fill: '#474B56',
            activeFill: '#1DE9AC',
            opacity: 1,
            selectedOpacity: 1,
            inactiveOpacity: 0.1,
            label: {
                stroke: '#1E2026',
                color: '#ACBAC7',
                activeColor: '#1DE9AC'
            }
        },
        arrow: {
            fill: '#474B56',
            activeFill: '#1DE9AC'
        }
    };

    const Sphere = ({ color, id, size, opacity, animated, onClick, onContextMenu }) => {
        const { scale, nodeOpacity } = three$1.useSpring({
            from: {
                // Note: This prevents incorrect scaling w/ 0
                scale: [0.00001, 0.00001, 0.00001],
                nodeOpacity: 0
            },
            to: {
                scale: [size, size, size],
                nodeOpacity: opacity
            },
            config: Object.assign(Object.assign({}, animationConfig), { duration: animated ? undefined : 0 })
        });
        const normalizedColor = react.useMemo(() => new three.Color(color), [color]);
        return (jsxRuntime.jsxs(three$1.a.mesh, Object.assign({ userData: { id, type: 'node' }, scale: scale, onClick: onClick, onPointerDown: event => {
                // context menu controls
                if (event.nativeEvent.buttons === 2) {
                    event.stopPropagation();
                    onContextMenu === null || onContextMenu === void 0 ? void 0 : onContextMenu();
                }
            } }, { children: [jsxRuntime.jsx("sphereBufferGeometry", { attach: "geometry", args: [1, 25, 25] }), jsxRuntime.jsx(three$1.a.meshPhongMaterial, { attach: "material", side: three.DoubleSide, transparent: true, fog: true, opacity: nodeOpacity, color: normalizedColor })] })));
    };
    Sphere.defaultProps = {
        opacity: 1,
        active: false,
        selected: false
    };

    const Icon = ({ image, id, size, opacity, animated, onClick, onContextMenu }) => {
        const texture = react.useMemo(() => new three.TextureLoader().load(image), [image]);
        const { scale, spriteOpacity } = three$1.useSpring({
            from: {
                scale: [0.00001, 0.00001, 0.00001],
                spriteOpacity: 0
            },
            to: {
                scale: [size, size, size],
                spriteOpacity: opacity
            },
            config: Object.assign(Object.assign({}, animationConfig), { duration: animated ? undefined : 0 })
        });
        return (jsxRuntime.jsx(three$1.a.sprite, Object.assign({ userData: { id, type: 'node' }, scale: scale, onClick: onClick, onPointerDown: event => {
                // context menu controls
                if (event.nativeEvent.buttons === 2) {
                    event.stopPropagation();
                    onContextMenu === null || onContextMenu === void 0 ? void 0 : onContextMenu();
                }
            } }, { children: jsxRuntime.jsx(three$1.a.spriteMaterial, Object.assign({ attach: "material", opacity: spriteOpacity, fog: true, depthTest: false, transparent: true, side: three.DoubleSide }, { children: jsxRuntime.jsx("primitive", { attach: "map", object: texture, minFilter: three.LinearFilter }) })) })));
    };
    Icon.defaultProps = {
        opacity: 1
    };

    const Ring = ({ color, size, opacity, animated }) => {
        const normalizedColor = react.useMemo(() => new three.Color(color), [color]);
        const { ringSize, ringOpacity } = three$1.useSpring({
            from: {
                ringOpacity: 0,
                ringSize: [0.00001, 0.00001, 0.00001]
            },
            to: {
                ringOpacity: opacity,
                ringSize: [size / 2, size / 2, 1]
            },
            config: Object.assign(Object.assign({}, animationConfig), { duration: animated ? undefined : 0 })
        });
        return (jsxRuntime.jsx(drei.Billboard, Object.assign({ position: [0, 0, 1] }, { children: jsxRuntime.jsxs(three$1.a.mesh, Object.assign({ scale: ringSize }, { children: [jsxRuntime.jsx("ringBufferGeometry", { attach: "geometry", args: [4, 4.5, 25] }), jsxRuntime.jsx(three$1.a.meshBasicMaterial, { attach: "material", color: normalizedColor, transparent: true, depthTest: false, opacity: ringOpacity, side: three.DoubleSide, fog: true })] })) })));
    };
    Ring.defaultProps = {
        color: '#D8E6EA',
        size: 1,
        opacity: 0.5
    };

    const CameraControlsContext = react.createContext({
        controls: null,
        zoomIn: () => undefined,
        zoomOut: () => undefined,
        panLeft: () => undefined,
        panRight: () => undefined,
        panUp: () => undefined,
        panDown: () => undefined
    });
    const useCameraControls = () => {
        const context = react.useContext(CameraControlsContext);
        if (context === undefined) {
            throw new Error('`useCameraControls` hook must be used within a `ControlsProvider` component');
        }
        return context;
    };

    // Install the camera controls
    // Use a subset for better three shaking
    ThreeCameraControls__default["default"].install({
        THREE: {
            MOUSE: three.MOUSE,
            Vector2: three.Vector2,
            Vector3: three.Vector3,
            Vector4: three.Vector4,
            Quaternion: three.Quaternion,
            Matrix4: three.Matrix4,
            Spherical: three.Spherical,
            Box3: three.Box3,
            Sphere: three.Sphere,
            Raycaster: three.Raycaster,
            MathUtils: {
                DEG2RAD: three.MathUtils === null || three.MathUtils === void 0 ? void 0 : three.MathUtils.DEG2RAD,
                clamp: three.MathUtils === null || three.MathUtils === void 0 ? void 0 : three.MathUtils.clamp
            }
        }
    });
    // Extend r3f with the new controls
    fiber.extend({ ThreeCameraControls: ThreeCameraControls__default["default"] });
    const KEY_CODES = {
        ARROW_LEFT: 37,
        ARROW_UP: 38,
        ARROW_RIGHT: 39,
        ARROW_DOWN: 40
    };
    const leftKey = new holdEvent__namespace.KeyboardKeyHold(KEY_CODES.ARROW_LEFT, 100);
    const rightKey = new holdEvent__namespace.KeyboardKeyHold(KEY_CODES.ARROW_RIGHT, 100);
    const upKey = new holdEvent__namespace.KeyboardKeyHold(KEY_CODES.ARROW_UP, 100);
    const downKey = new holdEvent__namespace.KeyboardKeyHold(KEY_CODES.ARROW_DOWN, 100);
    const CameraControls = react.forwardRef(({ mode, children, animated, disabled }, ref) => {
        const cameraRef = react.useRef(null);
        const { camera, gl } = fiber.useThree();
        const isOrbiting = mode === 'orbit';
        const setPanning = useStore(state => state.setPanning);
        fiber.useFrame((_state, delta) => {
            var _a;
            (_a = cameraRef.current) === null || _a === void 0 ? void 0 : _a.update(delta);
            if (isOrbiting) {
                cameraRef.current.azimuthAngle += 20 * delta * three.MathUtils.DEG2RAD;
            }
        });
        react.useEffect(() => () => { var _a; return (_a = cameraRef.current) === null || _a === void 0 ? void 0 : _a.dispose(); }, []);
        const zoomIn = react.useCallback(() => {
            var _a;
            (_a = cameraRef.current) === null || _a === void 0 ? void 0 : _a.zoom(camera.zoom / 2, animated);
        }, [animated, camera.zoom]);
        const zoomOut = react.useCallback(() => {
            var _a;
            (_a = cameraRef.current) === null || _a === void 0 ? void 0 : _a.zoom(-camera.zoom / 2, animated);
        }, [animated, camera.zoom]);
        const panRight = react.useCallback(event => {
            var _a;
            if (!isOrbiting) {
                (_a = cameraRef.current) === null || _a === void 0 ? void 0 : _a.truck(-0.03 * event.deltaTime, 0, animated);
            }
        }, [animated, isOrbiting]);
        const panLeft = react.useCallback(event => {
            var _a;
            if (!isOrbiting) {
                (_a = cameraRef.current) === null || _a === void 0 ? void 0 : _a.truck(0.03 * event.deltaTime, 0, animated);
            }
        }, [animated, isOrbiting]);
        const panUp = react.useCallback(event => {
            var _a;
            if (!isOrbiting) {
                (_a = cameraRef.current) === null || _a === void 0 ? void 0 : _a.truck(0, 0.03 * event.deltaTime, animated);
            }
        }, [animated, isOrbiting]);
        const panDown = react.useCallback(event => {
            var _a;
            if (!isOrbiting) {
                (_a = cameraRef.current) === null || _a === void 0 ? void 0 : _a.truck(0, -0.03 * event.deltaTime, animated);
            }
        }, [animated, isOrbiting]);
        const onKeyDown = react.useCallback(event => {
            if (event.code === 'Space') {
                if (mode === 'rotate') {
                    cameraRef.current.mouseButtons.left =
                        ThreeCameraControls__default["default"].ACTION.TRUCK;
                }
                else {
                    cameraRef.current.mouseButtons.left =
                        ThreeCameraControls__default["default"].ACTION.ROTATE;
                }
            }
        }, [mode]);
        const onKeyUp = react.useCallback(event => {
            if (event.code === 'Space') {
                if (mode === 'rotate') {
                    cameraRef.current.mouseButtons.left =
                        ThreeCameraControls__default["default"].ACTION.ROTATE;
                }
                else {
                    cameraRef.current.mouseButtons.left =
                        ThreeCameraControls__default["default"].ACTION.TRUCK;
                }
            }
        }, [mode]);
        react.useEffect(() => {
            leftKey.addEventListener('holding', panLeft);
            rightKey.addEventListener('holding', panRight);
            upKey.addEventListener('holding', panUp);
            downKey.addEventListener('holding', panDown);
            window.addEventListener('keydown', onKeyDown);
            window.addEventListener('keyup', onKeyUp);
            return () => {
                leftKey.removeEventListener('holding', panLeft);
                rightKey.removeEventListener('holding', panRight);
                upKey.removeEventListener('holding', panUp);
                downKey.removeEventListener('holding', panDown);
                window.removeEventListener('keydown', onKeyDown);
                window.removeEventListener('keyup', onKeyUp);
            };
        }, [onKeyDown, onKeyUp, panDown, panLeft, panRight, panUp]);
        react.useEffect(() => {
            const onControl = () => setPanning(true);
            const onControlEnd = () => setPanning(false);
            const ref = cameraRef.current;
            if (ref) {
                ref.addEventListener('control', onControl);
                ref.addEventListener('controlend', onControlEnd);
            }
            return () => {
                if (ref) {
                    ref.removeEventListener('control', onControl);
                    ref.removeEventListener('controlend', onControlEnd);
                }
            };
        }, [cameraRef, setPanning]);
        react.useEffect(() => {
            if (mode === 'rotate') {
                cameraRef.current.mouseButtons.left = ThreeCameraControls__default["default"].ACTION.ROTATE;
            }
            else {
                cameraRef.current.mouseButtons.left = ThreeCameraControls__default["default"].ACTION.TRUCK;
            }
        }, [mode]);
        reakeys.useHotkeys([
            {
                name: 'Zoom In',
                keys: 'command+shift+i',
                callback: event => {
                    event.preventDefault();
                    zoomIn();
                }
            },
            {
                name: 'Zoom Out',
                keys: 'command+shift+o',
                callback: event => {
                    event.preventDefault();
                    zoomOut();
                }
            }
        ]);
        const values = react.useMemo(() => ({
            controls: cameraRef.current,
            zoomIn: () => zoomIn(),
            zoomOut: () => zoomOut(),
            panLeft: () => panLeft({ deltaTime: 1 }),
            panRight: () => panRight({ deltaTime: 1 }),
            panDown: () => panDown({ deltaTime: 1 }),
            panUp: () => panUp({ deltaTime: 1 })
        }), 
        // eslint-disable-next-line
        [zoomIn, zoomOut, panLeft, panRight, panDown, panUp, cameraRef.current]);
        react.useImperativeHandle(ref, () => values);
        return (jsxRuntime.jsxs(CameraControlsContext.Provider, Object.assign({ value: values }, { children: [jsxRuntime.jsx("threeCameraControls", { ref: cameraRef, args: [camera, gl.domElement], enabled: !disabled, dampingFactor: 0.4 }), children] })));
    });
    CameraControls.defaultProps = {
        mode: 'rotate'
    };

    const useCenterGraph = ({ animated }) => {
        const nodes = useStore(state => state.nodes);
        const { invalidate } = fiber.useThree();
        const { controls } = useCameraControls();
        // Find the ideal spacing for focusing
        const centerPadding = react.useMemo(() => {
            const { maxX, maxY } = getLayoutCenter(nodes);
            return Math.max(maxX, maxY);
        }, [nodes]);
        const centerNodes = react.useCallback((centerNodes, padding = 50) => {
            requestAnimationFrame(() => {
                // Centers the graph based on the central most node
                const { minX, maxX, minY, maxY, minZ, maxZ } = getLayoutCenter(centerNodes);
                controls === null || controls === void 0 ? void 0 : controls.fitToBox(new three.Box3(new three.Vector3(minX, minY, minZ), new three.Vector3(maxX, maxY, maxZ)), animated, {
                    paddingLeft: padding,
                    paddingRight: padding,
                    paddingBottom: padding,
                    paddingTop: padding
                });
                invalidate();
            });
        }, [invalidate, controls, animated]);
        const centerNodesById = react.useCallback((nodeIds) => {
            let mappedNodes = null;
            let padding = 50;
            if (nodeIds === null || nodeIds === void 0 ? void 0 : nodeIds.length) {
                padding = centerPadding;
                mappedNodes = nodeIds.reduce((acc, id) => {
                    const node = nodes.find(n => n.id === id);
                    if (node) {
                        acc.push(node);
                    }
                    else {
                        throw new Error(`Attempted to center ${id} but it was not found in the nodes`);
                    }
                    return acc;
                }, []);
            }
            centerNodes(mappedNodes || nodes, padding);
        }, [centerNodes, nodes, centerPadding]);
        const mounted = react.useRef(false);
        react.useEffect(() => {
            // Center the graph once nodes are loaded on mount
            if (controls && (nodes === null || nodes === void 0 ? void 0 : nodes.length) && !mounted.current) {
                centerNodes(nodes);
                mounted.current = true;
            }
        }, [controls, centerNodes, nodes]);
        reakeys.useHotkeys([
            {
                name: 'Center',
                keys: ['command+shift+c'],
                callback: () => centerNodes(nodes)
            }
        ]);
        return { centerNodes, centerNodesById };
    };

    const useDrag = ({ draggable, set, position, onDragStart, onDragEnd }) => {
        const { raycaster, size, camera, gl } = fiber.useThree();
        // Reference: https://codesandbox.io/s/react-three-draggable-cxu37
        const { mouse2D, mouse3D, offset, normal, plane } = react.useMemo(() => ({
            // Normalized 2D screen space mouse coords
            mouse2D: new three.Vector2(),
            // 3D world space mouse coords
            mouse3D: new three.Vector3(),
            // Drag point offset from object origin
            offset: new three.Vector3(),
            // Normal of the drag plane
            normal: new three.Vector3(),
            // Drag plane
            plane: new three.Plane()
        }), []);
        const clientRect = react.useMemo(() => gl.domElement.getBoundingClientRect(), [gl.domElement]);
        return reactUseGesture.useGesture({
            onDragStart: ({ event }) => {
                // @ts-ignore
                const { eventObject, point } = event;
                // Save the offset of click point from object origin
                eventObject.getWorldPosition(offset).sub(point);
                // Set initial 3D cursor position (needed for onDrag plane calculation)
                mouse3D.copy(point);
                // Run user callback
                onDragStart();
            },
            onDrag: ({ event }) => {
                var _a, _b;
                // Compute normalized mouse coordinates (screen space)
                const nx = ((event.clientX - ((_a = clientRect === null || clientRect === void 0 ? void 0 : clientRect.left) !== null && _a !== void 0 ? _a : 0)) / size.width) * 2 - 1;
                const ny = -((event.clientY - ((_b = clientRect === null || clientRect === void 0 ? void 0 : clientRect.top) !== null && _b !== void 0 ? _b : 0)) / size.height) * 2 + 1;
                // Unlike the mouse from useThree, this works offscreen
                mouse2D.set(nx, ny);
                // Update raycaster (otherwise it doesn't track offscreen)
                raycaster.setFromCamera(mouse2D, camera);
                // The drag plane is normal to the camera view
                camera.getWorldDirection(normal).negate();
                // Find the plane that's normal to the camera and contains our drag point
                plane.setFromNormalAndCoplanarPoint(normal, mouse3D);
                // Find the point of intersection
                raycaster.ray.intersectPlane(plane, mouse3D);
                // Update the object position with the original offset
                const updated = new three.Vector3(position.x, position.y, position.z)
                    .copy(mouse3D)
                    .add(offset);
                return set(updated);
            },
            onDragEnd
        }, { drag: { enabled: draggable, threshold: 10 } });
    };

    const Node = ({ animated, disabled, id, draggable, theme, labelFontUrl, contextMenu, onClick, onPointerOver, onPointerOut, onContextMenu }) => {
        const cameraControls = useCameraControls();
        const node = useStore(state => state.nodes.find(n => n.id === id));
        const [graph, draggingId, collapsedNodeIds, setDraggingId, setNodePosition, setCollapsedNodeIds, panning] = useStore(state => [
            state.graph,
            state.draggingId,
            state.collapsedNodeIds,
            state.setDraggingId,
            state.setNodePosition,
            state.setCollapsedNodeIds,
            state.panning
        ]);
        const isDragging = draggingId === id;
        const { position, label, icon, size: nodeSize = 7, fill, labelVisible = true } = node;
        const { isSelected, hasSelections, isActive } = useStore(state => {
            var _a, _b, _c;
            return ({
                hasSelections: (_a = state.selections) === null || _a === void 0 ? void 0 : _a.length,
                isSelected: (_b = state.selections) === null || _b === void 0 ? void 0 : _b.includes(id),
                isActive: (_c = state.actives) === null || _c === void 0 ? void 0 : _c.includes(id)
            });
        });
        const group = react.useRef(null);
        const [active, setActive] = react.useState(false);
        const [menuVisible, setMenuVisible] = react.useState(false);
        let selectionOpacity = hasSelections
            ? isSelected || active || isActive
                ? theme.node.selectedOpacity
                : theme.node.inactiveOpacity
            : theme.node.opacity;
        selectionOpacity = node.hidden ? 0 : selectionOpacity;
        const canCollapse = react.useMemo(() => {
            // If the node has outgoing edges, it can collapse via context menu
            const links = graph.getLinks(id);
            const outboundLinks = links
                ? [...links].filter(l => l.data.source === id)
                : [];
            return outboundLinks.length > 0;
        }, [graph, id]);
        const isCollapsed = react.useMemo(() => collapsedNodeIds.includes(id), [collapsedNodeIds, id]);
        const onCollapse = react.useCallback(() => {
            if (canCollapse) {
                if (collapsedNodeIds.includes(id)) {
                    setCollapsedNodeIds([...collapsedNodeIds].filter(p => p !== id));
                }
                else {
                    setCollapsedNodeIds([...collapsedNodeIds, id]);
                }
            }
        }, [canCollapse, collapsedNodeIds, id, setCollapsedNodeIds]);
        const [{ nodePosition, labelPosition }] = three$1.useSpring(() => ({
            from: {
                nodePosition: [0, 0, 0],
                labelPosition: [0, -(nodeSize + 7), 2]
            },
            to: {
                nodePosition: position
                    ? [position.x, position.y, position.z]
                    : [0, 0, 0],
                labelPosition: [0, -(nodeSize + 7), 2]
            },
            config: Object.assign(Object.assign({}, animationConfig), { duration: animated && !draggingId ? undefined : 0 })
        }), [isDragging, position, animated, nodeSize]);
        const bind = useDrag({
            draggable,
            position,
            // @ts-ignore
            set: pos => setNodePosition(id, pos),
            onDragStart: () => {
                setDraggingId(id);
                setActive(true);
                cameraControls.controls.enabled = false;
            },
            onDragEnd: () => {
                setDraggingId(null);
                setActive(false);
                cameraControls.controls.enabled = true;
            }
        });
        drei.useCursor(active && !draggingId && onClick !== undefined, 'pointer');
        drei.useCursor(active && draggable && !isDragging && onClick === undefined, 'grab');
        drei.useCursor(isDragging, 'grabbing');
        return (jsxRuntime.jsxs(three$1.a.group, Object.assign({ ref: group, position: nodePosition, onPointerOver: () => {
                if (!disabled && !isDragging) {
                    setActive(true);
                }
                onPointerOver === null || onPointerOver === void 0 ? void 0 : onPointerOver(node);
            }, onPointerOut: () => {
                setActive(false);
                onPointerOut === null || onPointerOut === void 0 ? void 0 : onPointerOut(node);
            } }, bind(), { children: [icon ? (jsxRuntime.jsx(Icon, { id: id, image: icon, size: nodeSize + 8, opacity: selectionOpacity, animated: animated, onClick: () => {
                        if (!disabled && !isDragging) {
                            requestAnimationFrame(() => {
                                onClick === null || onClick === void 0 ? void 0 : onClick(node);
                            });
                        }
                    }, onContextMenu: () => {
                        if (!disabled) {
                            setMenuVisible(true);
                            onContextMenu === null || onContextMenu === void 0 ? void 0 : onContextMenu(node, { canCollapse, isCollapsed, onCollapse });
                        }
                    } })) : (jsxRuntime.jsx(Sphere, { id: id, size: nodeSize, color: isSelected || active || isDragging || isActive
                        ? theme.node.activeFill
                        : fill || theme.node.fill, opacity: selectionOpacity, animated: animated, onClick: () => {
                        if (!disabled && !isDragging) {
                            requestAnimationFrame(() => {
                                onClick === null || onClick === void 0 ? void 0 : onClick(node);
                            });
                        }
                    }, onContextMenu: () => {
                        if (!disabled) {
                            setMenuVisible(true);
                            onContextMenu === null || onContextMenu === void 0 ? void 0 : onContextMenu(node, { canCollapse, isCollapsed, onCollapse });
                        }
                    } })), jsxRuntime.jsx(Ring, { opacity: isSelected ? 0.5 : 0, size: nodeSize, animated: animated, color: isSelected || active ? theme.ring.activeFill : theme.ring.fill }), menuVisible && contextMenu && (jsxRuntime.jsx(drei.Html, Object.assign({ prepend: true, center: true }, { children: contextMenu({
                        data: node,
                        canCollapse,
                        isCollapsed,
                        onCollapse,
                        onClose: () => setMenuVisible(false)
                    }) }))), (labelVisible || isSelected || active) && label && (jsxRuntime.jsx(three$1.a.group, Object.assign({ position: labelPosition }, { children: jsxRuntime.jsx(Label, { text: label, fontUrl: labelFontUrl, opacity: selectionOpacity, stroke: theme.node.label.stroke, active: isSelected || active || isDragging || isActive, color: isSelected || active || isDragging || isActive
                            ? theme.node.label.activeColor
                            : theme.node.label.color }) })))] })));
    };
    Node.defaultProps = {
        draggable: false
    };

    const Arrow = ({ position, size, animated, opacity, placement, color, onActive, onContextMenu }) => {
        const normalizedColor = react.useMemo(() => new three.Color(color), [color]);
        const meshRef = react.useRef(null);
        const quaternion = react.useMemo(() => getQuaternion(position), [position]);
        const draggingId = useStore(state => state.draggingId);
        const [arrowLength, arrowSize] = react.useMemo(() => [size + 6, 2 + size / 1.5], [size]);
        const endPos = react.useMemo(() => {
            if (placement === 'mid') {
                return getMidPoint(position);
            }
            else if (placement === 'end') {
                return getArrowPosition(position, arrowLength);
            }
        }, [position, placement, arrowLength]);
        const [{ pos, arrowOpacity }] = three$1.useSpring(() => ({
            from: {
                pos: [0, 0, 0],
                arrowOpacity: 0
            },
            to: {
                pos: [endPos.x, endPos.y, endPos.z],
                arrowOpacity: opacity
            },
            config: Object.assign(Object.assign({}, animationConfig), { duration: animated && !draggingId ? undefined : 0 })
        }), [animated, draggingId, opacity, endPos]);
        const setQuaternion = react.useCallback(() => {
            var _a;
            (_a = meshRef.current) === null || _a === void 0 ? void 0 : _a.quaternion.setFromUnitVectors(quaternion[0], quaternion[1]);
        }, [quaternion, meshRef]);
        react.useEffect(() => setQuaternion(), [position, setQuaternion]);
        return (jsxRuntime.jsxs(three$1.a.mesh, Object.assign({ position: pos, ref: meshRef, scale: [1, 1, 1], onPointerOver: () => onActive(true), onPointerOut: () => onActive(false), onPointerDown: event => {
                // context menu controls
                if (event.nativeEvent.buttons === 2) {
                    event.stopPropagation();
                    onContextMenu();
                }
            } }, { children: [jsxRuntime.jsx("cylinderGeometry", { args: [0, arrowSize, arrowLength, 20, 20, true], attach: "geometry" }), jsxRuntime.jsx(three$1.a.meshBasicMaterial, { attach: "material", color: normalizedColor, depthTest: false, opacity: arrowOpacity, transparent: true, side: three.DoubleSide, fog: true })] })));
    };
    Arrow.defaultProps = {
        size: 1,
        opacity: 0.5,
        placement: 'end',
        color: '#D8E6EA'
    };

    const Line = ({ color, id, size, opacity, points, animated, onContextMenu, onActive, onClick, onPointerOver, onPointerOut }) => {
        const tubeRef = react.useRef(null);
        const draggingId = useStore(state => state.draggingId);
        const normalizedColor = react.useMemo(() => new three.Color(color), [color]);
        // Do opacity seperate from vertices for perf
        const { lineOpacity } = three$1.useSpring({
            from: {
                lineOpacity: 0
            },
            to: {
                lineOpacity: opacity
            },
            config: Object.assign(Object.assign({}, animationConfig), { duration: animated ? undefined : 0 })
        });
        three$1.useSpring(() => {
            var _a, _b, _c, _d, _e, _f;
            return ({
                from: {
                    fromVertices: [0, 0, 0],
                    toVertices: [0, 0, 0]
                },
                to: {
                    fromVertices: [(_a = points.from) === null || _a === void 0 ? void 0 : _a.x, (_b = points.from) === null || _b === void 0 ? void 0 : _b.y, ((_c = points.from) === null || _c === void 0 ? void 0 : _c.z) || 0],
                    toVertices: [(_d = points.to) === null || _d === void 0 ? void 0 : _d.x, (_e = points.to) === null || _e === void 0 ? void 0 : _e.y, ((_f = points.to) === null || _f === void 0 ? void 0 : _f.z) || 0]
                },
                onChange: event => {
                    const { fromVertices, toVertices } = event.value;
                    // Reference: https://bit.ly/3ORuuBP
                    const t = new three.CatmullRomCurve3([
                        new three.Vector3(...fromVertices),
                        new three.Vector3(...toVertices)
                    ]);
                    tubeRef.current.copy(new three.TubeBufferGeometry(t, 20, size / 2, 5, false));
                },
                config: Object.assign(Object.assign({}, animationConfig), { duration: animated && !draggingId ? undefined : 0 })
            });
        }, [animated, draggingId, points, size]);
        const curve = react.useMemo(() => new three.CatmullRomCurve3([new three.Vector3(0, 0, 0), new three.Vector3(0, 0, 0)]), []);
        return (jsxRuntime.jsxs("mesh", Object.assign({ userData: { id, type: 'edge' }, onPointerOver: () => {
                onActive(true);
                onPointerOver === null || onPointerOver === void 0 ? void 0 : onPointerOver();
            }, onPointerOut: () => {
                onActive(false);
                onPointerOut === null || onPointerOut === void 0 ? void 0 : onPointerOut();
            }, onClick: onClick, onPointerDown: event => {
                // context menu controls
                if (event.nativeEvent.buttons === 2) {
                    event.stopPropagation();
                    onContextMenu();
                }
            } }, { children: [jsxRuntime.jsx("tubeBufferGeometry", { attach: "geometry", args: [curve, 20, size / 2, 5, false], ref: tubeRef }), jsxRuntime.jsx(three$1.a.meshBasicMaterial, { attach: "material", opacity: lineOpacity, fog: true, transparent: true, depthTest: false, color: normalizedColor })] })));
    };
    Line.defaultProps = {
        color: '#000',
        size: 1,
        opacity: 1
    };

    const LABEL_FONT_SIZE = 6;
    const Edge = ({ id, animated, theme, disabled, labelPlacement, arrowPlacement, contextMenu, onContextMenu, onClick, onPointerOver, onPointerOut }) => {
        const edge = useStore(state => state.edges.find(e => e.id === id));
        const { toId, fromId, label, labelVisible = false, size = 1 } = edge;
        const from = useStore(store => store.nodes.find(node => node.id === fromId));
        const to = useStore(store => store.nodes.find(node => node.id === toId));
        const draggingId = useStore(state => state.draggingId);
        const [active, setActive] = react.useState(false);
        const [menuVisible, setMenuVisible] = react.useState(false);
        const labelOffset = (size + LABEL_FONT_SIZE) / 2;
        const points = react.useMemo(() => {
            // Handle arrow position offset
            const offset = arrowPlacement === 'end' ? to.size : 0;
            return getPoints({
                from,
                to: Object.assign(Object.assign({}, to), { size: offset + size + LABEL_FONT_SIZE })
            });
        }, [from, to, size, arrowPlacement]);
        const realPoints = react.useMemo(() => getPoints({ from, to }), [from, to]);
        const midPoint = react.useMemo(() => getMidPoint({ from: from.position, to: to.position }, getLabelOffsetByType(labelOffset, labelPlacement)), [from.position, to.position, labelOffset, labelPlacement]);
        const { isSelected, hasSelections, isActive } = useStore(state => {
            var _a, _b, _c;
            return ({
                hasSelections: (_a = state.selections) === null || _a === void 0 ? void 0 : _a.length,
                isSelected: (_b = state.selections) === null || _b === void 0 ? void 0 : _b.includes(id),
                isActive: (_c = state.actives) === null || _c === void 0 ? void 0 : _c.includes(id)
            });
        });
        let selectionOpacity = hasSelections
            ? isSelected || isActive
                ? theme.edge.selectedOpacity
                : theme.edge.inactiveOpacity
            : theme.edge.opacity;
        selectionOpacity = edge.hidden ? 0 : selectionOpacity;
        const [{ labelPosition }] = three$1.useSpring(() => ({
            from: {
                labelPosition: [0, 0, 0]
            },
            to: {
                labelPosition: [midPoint.x, midPoint.y, midPoint.z]
            },
            config: Object.assign(Object.assign({}, animationConfig), { duration: animated && !draggingId ? undefined : 0 })
        }), [midPoint, animated, draggingId]);
        const labelRotation = react.useMemo(() => new three.Euler(0, 0, labelPlacement === 'natural'
            ? 0
            : Math.atan((to.position.y - from.position.y) /
                (to.position.x - from.position.x))), [
            to.position.x,
            to.position.y,
            from.position.x,
            from.position.y,
            labelPlacement
        ]);
        drei.useCursor(active && !draggingId && onClick !== undefined, 'pointer');
        return (jsxRuntime.jsxs("group", { children: [jsxRuntime.jsx(Line, { id: id, opacity: selectionOpacity, points: points, size: size, animated: animated, onActive: setActive, color: isSelected || active || isActive
                        ? theme.edge.activeFill
                        : theme.edge.fill, onClick: () => {
                        if (!disabled) {
                            onClick === null || onClick === void 0 ? void 0 : onClick(edge);
                        }
                    }, onPointerOut: () => onPointerOut === null || onPointerOut === void 0 ? void 0 : onPointerOut(edge), onPointerOver: () => onPointerOver === null || onPointerOver === void 0 ? void 0 : onPointerOver(edge), onContextMenu: () => {
                        if (!disabled) {
                            setMenuVisible(true);
                            onContextMenu === null || onContextMenu === void 0 ? void 0 : onContextMenu(edge);
                        }
                    } }), arrowPlacement !== 'none' && (jsxRuntime.jsx(Arrow, { position: realPoints, opacity: selectionOpacity, size: size, animated: animated, placement: arrowPlacement, color: isSelected || active || isActive
                        ? theme.arrow.activeFill
                        : theme.arrow.fill, onActive: setActive, onContextMenu: () => {
                        if (!disabled) {
                            setMenuVisible(true);
                            onContextMenu === null || onContextMenu === void 0 ? void 0 : onContextMenu(edge);
                        }
                    } })), labelVisible && label && (jsxRuntime.jsx(three$1.a.group, Object.assign({ position: labelPosition, rotation: labelRotation }, { children: jsxRuntime.jsx(Label, { text: label, ellipsis: 15, stroke: theme.edge.label.stroke, color: isSelected || active || isActive
                            ? theme.edge.label.activeColor
                            : theme.edge.label.color, opacity: selectionOpacity, fontSize: LABEL_FONT_SIZE }) }))), menuVisible && contextMenu && (jsxRuntime.jsx(drei.Html, Object.assign({ prepend: true, center: true }, { children: contextMenu({ data: edge, onClose: () => setMenuVisible(false) }) })))] }));
    };
    Edge.defaultProps = {
        labelPlacement: 'inline'
    };

    const GraphScene = react.forwardRef((_a, ref) => {
        var { onNodeClick, onNodeContextMenu, onEdgeContextMenu, onEdgeClick, onEdgePointerOver, onEdgePointerOut, onNodePointerOver, onNodePointerOut, contextMenu, theme, animated, disabled, draggable, edgeLabelPosition, edgeArrowPosition, labelFontUrl } = _a, rest = __rest(_a, ["onNodeClick", "onNodeContextMenu", "onEdgeContextMenu", "onEdgeClick", "onEdgePointerOver", "onEdgePointerOut", "onNodePointerOver", "onNodePointerOut", "contextMenu", "theme", "animated", "disabled", "draggable", "edgeLabelPosition", "edgeArrowPosition", "labelFontUrl"]);
        const { mounted } = useGraph(rest);
        const [graph, nodes, edges] = useStore(state => [
            state.graph,
            state.nodes,
            state.edges
        ]);
        const nodeIds = react.useMemo(() => nodes.map(n => n.id), [nodes]);
        const edgeIds = react.useMemo(() => edges.map(e => e.id), [edges]);
        const { centerNodesById: centerGraph } = useCenterGraph({
            animated
        });
        react.useImperativeHandle(ref, () => ({
            centerGraph,
            graph
        }), [centerGraph, graph]);
        return (jsxRuntime.jsx(react.Fragment, { children: mounted && (jsxRuntime.jsxs(react.Fragment, { children: [nodeIds.map(n => (jsxRuntime.jsx(Node, { id: n, labelFontUrl: labelFontUrl, draggable: draggable, disabled: disabled, animated: animated, theme: theme, contextMenu: contextMenu, onClick: onNodeClick, onContextMenu: onNodeContextMenu, onPointerOver: onNodePointerOver, onPointerOut: onNodePointerOut }, n))), edgeIds.map(e => (jsxRuntime.jsx(Edge, { theme: theme, id: e, disabled: disabled, animated: animated, labelPlacement: edgeLabelPosition, arrowPlacement: edgeArrowPosition, contextMenu: contextMenu, onClick: onEdgeClick, onContextMenu: onEdgeContextMenu, onPointerOver: onEdgePointerOver, onPointerOut: onEdgePointerOut }, e)))] })) }));
    });

    function styleInject(css, ref) {
      if ( ref === void 0 ) ref = {};
      var insertAt = ref.insertAt;

      if (!css || typeof document === 'undefined') { return; }

      var head = document.head || document.getElementsByTagName('head')[0];
      var style = document.createElement('style');
      style.type = 'text/css';

      if (insertAt === 'top') {
        if (head.firstChild) {
          head.insertBefore(style, head.firstChild);
        } else {
          head.appendChild(style);
        }
      } else {
        head.appendChild(style);
      }

      if (style.styleSheet) {
        style.styleSheet.cssText = css;
      } else {
        style.appendChild(document.createTextNode(css));
      }
    }

    var css_248z$2 = ".GraphCanvas-module_canvas__3uJtk {\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n}\n";
    var css$2 = {"canvas":"GraphCanvas-module_canvas__3uJtk"};
    styleInject(css_248z$2);

    function prepareRay(event, vec, size) {
        const { offsetX, offsetY } = event;
        const { width, height } = size;
        vec.set((offsetX / width) * 2 - 1, -(offsetY / height) * 2 + 1);
    }
    function createElement(theme) {
        const element = document.createElement('div');
        element.style.pointerEvents = 'none';
        element.style.border = theme.lasso.border;
        element.style.backgroundColor = theme.lasso.background;
        element.style.position = 'fixed';
        return element;
    }
    const Lasso = ({ children, theme, type = 'none', onLasso, onLassoEnd, disabled }) => {
        var _a;
        const { setEvents, camera, gl, size, get } = fiber.useThree();
        const cameraControls = useCameraControls();
        const ref = react.useRef(null);
        const [actives, setActives] = useStore(state => [
            state.actives,
            state.setActives
        ]);
        const mountedRef = react.useRef(false);
        const selectionBoxRef = react.useRef(null);
        const elementRef = react.useRef(createElement(theme));
        const vectorsRef = react.useRef(null);
        const isDownRef = react.useRef(false);
        const prevRef = react.useRef([]);
        const oldRaycasterEnabledRef = react.useRef(get().events.enabled);
        const oldControlsEnabledRef = react.useRef((_a = cameraControls.controls) === null || _a === void 0 ? void 0 : _a.enabled);
        react.useEffect(() => {
            if (mountedRef.current) {
                onLasso === null || onLasso === void 0 ? void 0 : onLasso(actives);
            }
            mountedRef.current = true;
        }, [actives, onLasso]);
        const onPointerDown = react.useCallback(event => {
            var _a, _b;
            if (event.shiftKey) {
                // Let's capture the old props to restore them later
                oldRaycasterEnabledRef.current = get().events.enabled;
                oldControlsEnabledRef.current = (_a = cameraControls.controls) === null || _a === void 0 ? void 0 : _a.enabled;
                // initalize some new vectors
                selectionBoxRef.current = new threeStdlib.SelectionBox(camera, ref.current);
                vectorsRef.current = [
                    // start point
                    new three.Vector2(),
                    // point top left
                    new three.Vector2(),
                    // point bottom right
                    new three.Vector2()
                ];
                const [startPoint] = vectorsRef.current;
                cameraControls.controls.enabled = false;
                setEvents({ enabled: false });
                isDownRef.current = true;
                (_b = gl.domElement.parentElement) === null || _b === void 0 ? void 0 : _b.appendChild(elementRef.current);
                elementRef.current.style.left = `${event.clientX}px`;
                elementRef.current.style.top = `${event.clientY}px`;
                elementRef.current.style.width = '0px';
                elementRef.current.style.height = '0px';
                startPoint.x = event.clientX;
                startPoint.y = event.clientY;
                prepareRay(event, selectionBoxRef.current.startPoint, size);
            }
        }, [
            camera,
            cameraControls.controls,
            get,
            gl.domElement.parentElement,
            setEvents,
            size
        ]);
        const onPointerMove = react.useCallback(event => {
            if (isDownRef.current) {
                const [startPoint, pointTopLeft, pointBottomRight] = vectorsRef.current;
                pointBottomRight.x = Math.max(startPoint.x, event.clientX);
                pointBottomRight.y = Math.max(startPoint.y, event.clientY);
                pointTopLeft.x = Math.min(startPoint.x, event.clientX);
                pointTopLeft.y = Math.min(startPoint.y, event.clientY);
                elementRef.current.style.left = `${pointTopLeft.x}px`;
                elementRef.current.style.top = `${pointTopLeft.y}px`;
                elementRef.current.style.width = `${pointBottomRight.x - pointTopLeft.x}px`;
                elementRef.current.style.height = `${pointBottomRight.y - pointTopLeft.y}px`;
                prepareRay(event, selectionBoxRef.current.endPoint, size);
                const allSelected = selectionBoxRef.current
                    .select()
                    .sort(o => o.uuid)
                    .filter(o => {
                    var _a, _b;
                    return o.isMesh &&
                        ((_a = o.userData) === null || _a === void 0 ? void 0 : _a.id) &&
                        (((_b = o.userData) === null || _b === void 0 ? void 0 : _b.type) === type || type === 'all');
                });
                if (!shallow__default["default"](allSelected, prevRef.current)) {
                    prevRef.current = allSelected;
                    setActives(allSelected.map(o => o.userData.id));
                }
            }
        }, [setActives, size, type]);
        const onPointerUp = react.useCallback(() => {
            var _a;
            if (isDownRef.current) {
                setEvents({ enabled: oldRaycasterEnabledRef.current });
                isDownRef.current = false;
                (_a = elementRef.current.parentElement) === null || _a === void 0 ? void 0 : _a.removeChild(elementRef.current);
                cameraControls.controls.enabled = oldControlsEnabledRef.current;
                onLassoEnd === null || onLassoEnd === void 0 ? void 0 : onLassoEnd(actives);
            }
        }, [setEvents, cameraControls.controls, onLassoEnd, actives]);
        react.useEffect(() => {
            if (disabled || type === 'none') {
                return;
            }
            document.addEventListener('pointerdown', onPointerDown, { passive: true });
            document.addEventListener('pointermove', onPointerMove, {
                passive: true,
                capture: true
            });
            document.addEventListener('pointerup', onPointerUp, { passive: true });
            return () => {
                document.removeEventListener('pointerdown', onPointerDown);
                document.removeEventListener('pointermove', onPointerMove);
                document.removeEventListener('pointerup', onPointerUp);
            };
        }, [type, disabled, onPointerDown, onPointerMove, onPointerUp]);
        return jsxRuntime.jsx("group", Object.assign({ ref: ref }, { children: children }));
    };

    function findPath(graph, fromId, toId) {
        const pathFinder = path__default["default"].aStar(graph);
        const foundPath = pathFinder.find(fromId, toId);
        return foundPath;
    }

    const getAdjacents = (graph, nodeIds, type) => {
        nodeIds = Array.isArray(nodeIds) ? nodeIds : [nodeIds];
        const nodes = [];
        const edges = [];
        for (const nodeId of nodeIds) {
            const graphLinks = graph.getLinks(nodeId);
            if (!graphLinks) {
                continue;
            }
            graphLinks.forEach(link => {
                const linkId = link.data.id;
                if (type === 'in') {
                    if (link.toId === nodeId && !edges.includes(linkId)) {
                        edges.push(linkId);
                    }
                }
                else if (type === 'out') {
                    if (link.fromId === nodeId && !edges.includes(linkId)) {
                        edges.push(linkId);
                    }
                }
                else {
                    if (!edges.includes(linkId)) {
                        edges.push(linkId);
                    }
                }
                if (type === 'out' || type === 'all') {
                    const toId = link.toId;
                    if (!nodes.includes(toId)) {
                        nodes.push(toId);
                    }
                }
                if (type === 'in' || type === 'all') {
                    const fromId = link.fromId;
                    if (!nodes.includes(fromId)) {
                        nodes.push(fromId);
                    }
                }
            });
        }
        return [...nodes, ...edges];
    };

    const useSelection = ({ selections = [], nodes = [], actives = [], focusOnSelect = true, type = 'single', pathHoverType = 'out', pathSelectionType = 'direct', ref, hotkeys = ['selectAll', 'deselect', 'delete'], disabled, onSelection }) => {
        const [internalHovers, setInternalHovers] = react.useState([]);
        const [internalActives, setInternalActives] = react.useState(actives);
        const [internalSelections, setInternalSelections] = react.useState(selections);
        const [metaKeyDown, setMetaKeyDown] = react.useState(false);
        const isMulti = type === 'multi' || type === 'multiModifier';
        const addSelection = react.useCallback((items) => {
            if (!disabled && items) {
                items = Array.isArray(items) ? items : [items];
                const filtered = items.filter(item => !internalSelections.includes(item));
                if (filtered.length) {
                    const next = [...internalSelections, ...filtered];
                    onSelection === null || onSelection === void 0 ? void 0 : onSelection(next);
                    setInternalSelections(next);
                }
            }
        }, [disabled, internalSelections, onSelection]);
        const removeSelection = react.useCallback((items) => {
            if (!disabled && items) {
                items = Array.isArray(items) ? items : [items];
                const next = internalSelections.filter(i => !items.includes(i));
                onSelection === null || onSelection === void 0 ? void 0 : onSelection(next);
                setInternalSelections(next);
            }
        }, [disabled, internalSelections, onSelection]);
        const clearSelections = react.useCallback((next = []) => {
            if (!disabled) {
                next = Array.isArray(next) ? next : [next];
                setInternalActives([]);
                setInternalSelections(next);
                onSelection === null || onSelection === void 0 ? void 0 : onSelection(next);
            }
        }, [disabled, onSelection]);
        const toggleSelection = react.useCallback((item) => {
            const has = internalSelections.includes(item);
            if (has) {
                removeSelection(item);
            }
            else {
                if (!isMulti) {
                    clearSelections(item);
                }
                else {
                    addSelection(item);
                }
            }
        }, [
            addSelection,
            clearSelections,
            internalSelections,
            isMulti,
            removeSelection
        ]);
        const onNodeClick = react.useCallback((data) => {
            var _a;
            if (isMulti) {
                if (type === 'multiModifier') {
                    if (metaKeyDown) {
                        addSelection(data.id);
                    }
                    else {
                        clearSelections(data.id);
                    }
                }
                else {
                    addSelection(data.id);
                }
            }
            else {
                clearSelections(data.id);
            }
            if (focusOnSelect) {
                if (!ref.current) {
                    throw new Error('No ref found for the graph canvas.');
                }
                (_a = ref.current) === null || _a === void 0 ? void 0 : _a.centerGraph([data.id]);
            }
        }, [
            addSelection,
            clearSelections,
            focusOnSelect,
            isMulti,
            metaKeyDown,
            ref,
            type
        ]);
        const selectNodePaths = react.useCallback((fromId, toId) => {
            const graph = ref.current.getGraph();
            if (!graph) {
                throw new Error('Graph is not initialized');
            }
            const path = findPath(graph, fromId, toId);
            clearSelections([fromId, toId]);
            const result = [];
            for (let i = 0; i < path.length - 1; i++) {
                const from = path[i];
                const to = path[i + 1];
                const edge = graph.getLink(to.data.id, from.data.id);
                if (edge) {
                    result.push(edge.data.id);
                }
            }
            setInternalActives([...path.map(p => p.id), ...result]);
        }, [clearSelections, ref]);
        const onKeyDown = react.useCallback((event) => {
            const element = event.target;
            const isSafe = element.tagName !== 'INPUT' &&
                element.tagName !== 'SELECT' &&
                element.tagName !== 'TEXTAREA' &&
                !element.isContentEditable;
            if (isSafe) {
                event.preventDefault();
                setMetaKeyDown(event.metaKey || event.ctrlKey);
            }
        }, []);
        react.useEffect(() => {
            window.addEventListener('keydown', onKeyDown);
            return () => {
                window.removeEventListener('keydown', onKeyDown);
            };
        }, [onKeyDown]);
        const onCanvasClick = react.useCallback((event) => {
            var _a;
            if (event.button !== 2 &&
                (internalSelections.length || internalActives.length)) {
                clearSelections();
                setMetaKeyDown(false);
                // Only re-center if we have a single selection
                if (focusOnSelect && internalSelections.length === 1) {
                    if (!ref.current) {
                        throw new Error('No ref found for the graph canvas.');
                    }
                    (_a = ref.current) === null || _a === void 0 ? void 0 : _a.centerGraph();
                }
            }
        }, [
            clearSelections,
            focusOnSelect,
            internalActives.length,
            internalSelections.length,
            ref
        ]);
        const onLasso = react.useCallback((selections) => {
            setInternalActives(selections);
        }, []);
        const onLassoEnd = react.useCallback((selections) => {
            clearSelections(selections);
        }, [clearSelections]);
        const onNodePointerOver = react.useCallback((data) => {
            if (pathHoverType) {
                const graph = ref.current.getGraph();
                if (!graph) {
                    throw new Error('No ref found for the graph canvas.');
                }
                setInternalHovers(getAdjacents(graph, [data.id], pathHoverType));
            }
        }, [pathHoverType, ref]);
        const onNodePointerOut = react.useCallback(() => {
            if (pathHoverType) {
                setInternalHovers([]);
            }
        }, [pathHoverType]);
        react.useEffect(() => {
            var _a;
            if (pathSelectionType !== 'direct' && internalSelections.length > 0) {
                const graph = (_a = ref.current) === null || _a === void 0 ? void 0 : _a.getGraph();
                if (graph) {
                    setInternalActives(getAdjacents(graph, internalSelections, pathSelectionType));
                }
            }
        }, [internalSelections, pathSelectionType, ref]);
        reakeys.useHotkeys([
            {
                name: 'Select All',
                keys: 'mod+a',
                disabled: !hotkeys.includes('selectAll'),
                category: 'Canvas',
                description: 'Select all nodes and edges',
                callback: event => {
                    event.preventDefault();
                    if (!disabled && type !== 'single') {
                        const next = nodes.map(n => n.id);
                        onSelection === null || onSelection === void 0 ? void 0 : onSelection(next);
                        setInternalSelections(next);
                    }
                }
            },
            {
                name: 'Deselect Selections',
                category: 'Canvas',
                disabled: !hotkeys.includes('deselect'),
                description: 'Deselect selected nodes and edges',
                keys: 'escape',
                callback: event => {
                    if (!disabled) {
                        event.preventDefault();
                        onSelection === null || onSelection === void 0 ? void 0 : onSelection([]);
                        setInternalSelections([]);
                    }
                }
            }
        ]);
        const joinedActives = react.useMemo(() => [...internalActives, ...internalHovers], [internalActives, internalHovers]);
        return {
            actives: joinedActives,
            onNodeClick,
            onNodePointerOver,
            onNodePointerOut,
            onLasso,
            onLassoEnd,
            selectNodePaths,
            onCanvasClick,
            selections: internalSelections,
            clearSelections,
            addSelection,
            removeSelection,
            toggleSelection,
            setSelections: setInternalSelections
        };
    };

    const GL_DEFAULTS = {
        alpha: true,
        antialias: true
    };
    // TODO: Fix type
    const CAMERA_DEFAULTS = {
        position: [0, 0, 1000],
        near: 5,
        far: 10000,
        fov: 10
    };
    const GraphCanvas = react.forwardRef((_a, ref) => {
        var { cameraMode, theme, onCanvasClick, animated, disabled, lassoType, onLasso, onLassoEnd } = _a, rest = __rest(_a, ["cameraMode", "theme", "onCanvasClick", "animated", "disabled", "lassoType", "onLasso", "onLassoEnd"]);
        const rendererRef = react.useRef(null);
        const controlsRef = react.useRef(null);
        react.useImperativeHandle(ref, () => ({
            centerGraph: (n) => { var _a; return (_a = rendererRef.current) === null || _a === void 0 ? void 0 : _a.centerGraph(n); },
            zoomIn: () => { var _a; return (_a = controlsRef.current) === null || _a === void 0 ? void 0 : _a.zoomIn(); },
            zoomOut: () => { var _a; return (_a = controlsRef.current) === null || _a === void 0 ? void 0 : _a.zoomOut(); },
            panLeft: () => { var _a; return (_a = controlsRef.current) === null || _a === void 0 ? void 0 : _a.panLeft(); },
            panRight: () => { var _a; return (_a = controlsRef.current) === null || _a === void 0 ? void 0 : _a.panRight(); },
            panDown: () => { var _a; return (_a = controlsRef.current) === null || _a === void 0 ? void 0 : _a.panDown(); },
            panUp: () => { var _a; return (_a = controlsRef.current) === null || _a === void 0 ? void 0 : _a.panUp(); },
            getControls: () => { var _a; return (_a = controlsRef.current) === null || _a === void 0 ? void 0 : _a.controls; },
            getGraph: () => { var _a; return (_a = rendererRef.current) === null || _a === void 0 ? void 0 : _a.graph; }
        }));
        // NOTE: The legacy/linear/flat flags are for color issues
        // Reference: https://github.com/protectwise/troika/discussions/213#discussioncomment-3086666
        return (jsxRuntime.jsx("div", Object.assign({ className: css$2.canvas }, { children: jsxRuntime.jsx(fiber.Canvas, Object.assign({ legacy: true, linear: true, flat: true, gl: GL_DEFAULTS, camera: CAMERA_DEFAULTS, onPointerMissed: onCanvasClick }, { children: jsxRuntime.jsxs(Provider, Object.assign({ createStore: createStore }, { children: [jsxRuntime.jsx("color", { attach: "background", args: [theme.canvas.background] }), jsxRuntime.jsx("ambientLight", { intensity: 1 }), jsxRuntime.jsx("fog", { attach: "fog", args: [theme.canvas.fog, 4000, 9000] }), jsxRuntime.jsx(CameraControls, Object.assign({ mode: cameraMode, ref: controlsRef, animated: animated, disabled: disabled }, { children: jsxRuntime.jsx(Lasso, Object.assign({ theme: theme, disabled: disabled, type: lassoType, onLasso: onLasso, onLassoEnd: onLassoEnd }, { children: jsxRuntime.jsx(react.Suspense, { children: jsxRuntime.jsx(GraphScene, Object.assign({ ref: rendererRef, theme: theme, disabled: disabled, animated: animated }, rest)) }) })) }))] })) })) })));
    });
    GraphCanvas.defaultProps = {
        cameraMode: 'pan',
        layoutType: 'forceDirected2d',
        sizingType: 'none',
        labelType: 'auto',
        theme: lightTheme,
        animated: true,
        defaultNodeSize: 7,
        minNodeSize: 5,
        maxNodeSize: 15,
        lassoType: 'none'
    };

    var css_248z$1 = ".RadialSlice-module_container__3sdPx {\n  transform-origin: bottom right;\n  overflow: hidden;\n  position: absolute;\n  border: solid 1px var(--radial-menu-border);\n}\n\n  .RadialSlice-module_container__3sdPx.RadialSlice-module_disabled__ERjv5 {\n    opacity: 0.6;\n  }\n\n  .RadialSlice-module_container__3sdPx.RadialSlice-module_disabled__ERjv5 .RadialSlice-module_contentContainer__3uhQD {\n      cursor: not-allowed;\n    }\n\n  .RadialSlice-module_container__3sdPx:not(.RadialSlice-module_disabled__ERjv5) .RadialSlice-module_contentContainer__3uhQD {\n      cursor: pointer;\n    }\n\n  .RadialSlice-module_container__3sdPx:not(.RadialSlice-module_disabled__ERjv5) .RadialSlice-module_contentContainer__3uhQD:hover {\n        color: var(--radial-menu-active-color);\n        background: var(--radial-menu-active-background);\n      }\n\n  .RadialSlice-module_container__3sdPx .RadialSlice-module_contentContainer__3uhQD {\n    width: 200%;\n    height: 200%;\n    transform-origin: 50% 50%;\n    border-radius: 50%;\n    outline: none;\n    transition: background 150ms ease-in-out;\n    color: var(--radial-menu-color);\n  }\n\n  .RadialSlice-module_container__3sdPx .RadialSlice-module_contentContainer__3uhQD .RadialSlice-module_contentInner__s-xvr {\n      position: absolute;\n      width: 100%;\n      text-align: center;\n    }\n\n  .RadialSlice-module_container__3sdPx .RadialSlice-module_contentContainer__3uhQD .RadialSlice-module_contentInner__s-xvr .RadialSlice-module_content__2Kgsk {\n        display: inline-block;\n      }\n\n  .RadialSlice-module_container__3sdPx svg {\n    margin: 0 auto;\n    fill: var(--radial-menu-active-color);\n    height: 25px;\n    width: 25px;\n    display: block;\n  }\n";
    var css$1 = {"container":"RadialSlice-module_container__3sdPx","disabled":"RadialSlice-module_disabled__ERjv5","contentContainer":"RadialSlice-module_contentContainer__3uhQD","contentInner":"RadialSlice-module_contentInner__s-xvr","content":"RadialSlice-module_content__2Kgsk"};
    styleInject(css_248z$1);

    const RadialSlice = ({ label, centralAngle, startAngle, endAngle, polar, radius, icon, innerRadius, skew, disabled, onClick }) => (jsxRuntime.jsx("div", Object.assign({ role: "menuitem", className: classNames__default["default"](css$1.container, { [css$1.disabled]: disabled }), style: {
            width: centralAngle > 90 ? '100%' : '50%',
            height: centralAngle > 90 ? '100%' : '50%',
            bottom: centralAngle > 90 ? '50%' : 'initial',
            right: centralAngle > 90 ? '50%' : 'initial',
            transform: `rotate(${startAngle + endAngle}deg) skew(${skew}deg)`
        }, onClick: event => {
            if (!disabled) {
                onClick(event);
            }
        } }, { children: jsxRuntime.jsx("div", Object.assign({ className: css$1.contentContainer, style: {
                transform: `skew(${-skew}deg) rotate(${(polar ? 90 : centralAngle) / 2 - 90}deg)`
            } }, { children: jsxRuntime.jsx("div", Object.assign({ className: css$1.contentInner, style: {
                    top: `calc((((${centralAngle > 90 ? '50% + ' : ''}${radius}px) - ${innerRadius}px) / 2) - 4em)`
                } }, { children: jsxRuntime.jsxs("div", Object.assign({ className: css$1.content, style: {
                        transform: `rotate(${-endAngle}deg)`
                    }, title: label }, { children: [icon, label] })) })) })) })));

    function calculateRadius(items, startOffsetAngle) {
        const centralAngle = 360 / items.length || 360;
        const polar = centralAngle % 180 === 0;
        const deltaAngle = 90 - centralAngle;
        const startAngle = polar
            ? 45
            : startOffsetAngle + deltaAngle + centralAngle / 2;
        return { centralAngle, polar, startAngle, deltaAngle };
    }

    var css_248z = ".RadialMenu-module_container__3paz2 {\n  border-radius: 50%;\n  z-index: 9;\n  position: relative;\n  height: 175px;\n  width: 175px;\n  border: solid 5px var(--radial-menu-border);\n  overflow: hidden;\n  background: var(--radial-menu-background);\n}\n\n  .RadialMenu-module_container__3paz2:before {\n    content: ' ';\n    background: var(--radial-menu-border);\n    border-radius: 50%;\n    height: 25px;\n    width: 25px;\n    position: absolute;\n    z-index: 9;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n  }\n";
    var css = {"container":"RadialMenu-module_container__3paz2"};
    styleInject(css_248z);

    const RadialMenu = ({ items, radius, innerRadius, startOffsetAngle, onClose }) => {
        const { centralAngle, polar, startAngle, deltaAngle } = react.useMemo(() => calculateRadius(items, startOffsetAngle), [items, startOffsetAngle]);
        const timeout = react.useRef(null);
        react.useLayoutEffect(() => {
            const timer = timeout.current;
            return () => clearTimeout(timer);
        }, []);
        if (items.length === 0) {
            return null;
        }
        return (jsxRuntime.jsx("div", Object.assign({ role: "menu", className: css.container, onPointerEnter: () => clearTimeout(timeout.current), onPointerLeave: event => {
                clearTimeout(timeout.current);
                timeout.current = setTimeout(() => onClose === null || onClose === void 0 ? void 0 : onClose(event), 500);
            } }, { children: items.map((slice, index) => (jsxRuntime.jsx(RadialSlice, Object.assign({}, slice, { radius: radius, innerRadius: innerRadius, startAngle: startAngle, endAngle: centralAngle * index, skew: polar ? 0 : deltaAngle, polar: polar, centralAngle: centralAngle, onClick: event => {
                    slice === null || slice === void 0 ? void 0 : slice.onClick(event);
                    onClose === null || onClose === void 0 ? void 0 : onClose(event);
                } }), index))) })));
    };
    RadialMenu.defaultProps = {
        radius: 175,
        innerRadius: 25,
        startOffsetAngle: 0
    };

    exports.Arrow = Arrow;
    exports.CameraControls = CameraControls;
    exports.CameraControlsContext = CameraControlsContext;
    exports.Edge = Edge;
    exports.GraphCanvas = GraphCanvas;
    exports.GraphScene = GraphScene;
    exports.Icon = Icon;
    exports.Label = Label;
    exports.Lasso = Lasso;
    exports.Line = Line;
    exports.Node = Node;
    exports.RadialMenu = RadialMenu;
    exports.RadialSlice = RadialSlice;
    exports.Ring = Ring;
    exports.Sphere = Sphere;
    exports.animationConfig = animationConfig;
    exports.attributeSizing = attributeSizing;
    exports.calcLabelVisibility = calcLabelVisibility;
    exports.centralitySizing = centralitySizing;
    exports.circular2d = circular2d;
    exports.darkTheme = darkTheme;
    exports.forceDirected = forceDirected;
    exports.forceRadial = forceRadial;
    exports.getAdjacents = getAdjacents;
    exports.getArrowPosition = getArrowPosition;
    exports.getLabelOffsetByType = getLabelOffsetByType;
    exports.getLayoutCenter = getLayoutCenter;
    exports.getMidPoint = getMidPoint;
    exports.getNodeDepth = getNodeDepth;
    exports.getPoints = getPoints;
    exports.getQuaternion = getQuaternion;
    exports.getUpdatedCollapsedState = getUpdatedCollapsedState;
    exports.layoutProvider = layoutProvider;
    exports.lightTheme = lightTheme;
    exports.nodeSizeProvider = nodeSizeProvider;
    exports.pageRankSizing = pageRankSizing;
    exports.recommendLayout = recommendLayout;
    exports.tick = tick;
    exports.useCameraControls = useCameraControls;
    exports.useCenterGraph = useCenterGraph;
    exports.useGraph = useGraph;
    exports.useSelection = useSelection;

    Object.defineProperty(exports, '__esModule', { value: true });

}));
